import { render, staticRenderFns } from "./DropdownStatus.vue?vue&type=template&id=1fd88148&scoped=true"
import script from "./DropdownStatus.vue?vue&type=script&lang=js"
export * from "./DropdownStatus.vue?vue&type=script&lang=js"
import style0 from "./DropdownStatus.vue?vue&type=style&index=0&id=1fd88148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd88148",
  null
  
)

export default component.exports